export const RischiHelpers = () => {

    const CountRischiLivelloStats = (rischi) => {
        let rischioEff1 = 0; let rischioEff2 = 0; let rischioEff3 = 0; let rischioEff4 = 0;
        for (let i = 0; i < rischi.length; i++) {
            const rischio = rischi[i];
            if (rischio.EfTotale >= 1 && rischio.EfTotale <= 1.5) {
                rischioEff1 ++;
            } else if (rischio.EfTotale > 1.5 && rischio.EfTotale <= 2.5) {
                rischioEff2 ++;
            } else if (rischio.EfTotale > 2.5 && rischio.EfTotale <= 3.5) {
                rischioEff3 ++;
            } else if (rischio.EfTotale > 3.5) {
                rischioEff4 ++;
            }
        }
        return {rischioEff1, rischioEff2, rischioEff3, rischioEff4};
    }

    return{
        CountRischiLivelloStats
    }
}

export default RischiHelpers;